import loadable from 'sku/@loadable/component';

const BrowserUpgrade = loadable(
  () =>
    // @ts-ignore
    import('../pages/browser-upgrade/App/App'),
);
// @ts-ignore
const ContactUs = loadable(() => import('../pages/contact-us/App/App'));
const ClearBrowserHistory = loadable(
  () =>
    // @ts-ignore
    import('../pages/clear-browser-history/App/App'),
);

const AccountDeleted = loadable(
  () => import('../pages/account-deleted/App/App'),
);

const IdentityError = loadable(() => import('../pages/identity-error/App/App'));

const NotFound = loadable(() => import('../pages/error/not-found/App'));

const Forbidden = loadable(() => import('../pages/error/forbidden/App'));

const ServerError = loadable(() => import('../pages/error/server-error/App'));

const Maintenance = loadable(() => import('../pages/error/maintenance/App'));

export default {
  'browser-upgrade': BrowserUpgrade,
  'contact-us': ContactUs,
  'clear-browser-history': ClearBrowserHistory,
  'account-deleted': AccountDeleted,
  'identity-error': IdentityError,
  'not-found': NotFound,
  forbidden: Forbidden,
  'server-error': ServerError,
  maintenance: Maintenance,
};
